import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "focus-visible:ring-ring ring-offset-background inline-flex gap-2 items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/80 ring-0",
        outline:
          "border border-primary font-bold text-primary hover:bg-accent hover:text-accent-foreground",
        outlineSecondary: "border border-input hover:bg-secondary hover:text-secondary-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        gradient:
          "bg-gradient-to-tr from-brand-gradient-end to-brand-gradient-start text-primary-foreground hover:bg-gradient-to-tr",
      },
      size: {
        default: "h-8 px-3 py-1.5",
        icon: "size-8 p-0",
        comfortable: "h-10 px-4",
        sm: "h-7 rounded-lg px-2.5",
        lg: "h-9 rounded-lg px-6",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
